<template>
  <q-layout view="hHh Lpr lff"> <!-- Be sure to play with the Layout demo on docs -->

    <!-- (Optional) The Header -->
    <q-header >
      <q-toolbar>
        <q-toolbar-title>
          Submind
          <span slot="subtitle">+Coders Notes</span>
        </q-toolbar-title>
        <q-btn
          flat
          @click="showLoginDialog">
          Login/Register
        </q-btn>
      </q-toolbar>
    </q-header>

    <q-page-container>
      <!-- This is where pages get injected -->
      <router-view />
    </q-page-container>

    <q-dialog v-model="firestoreLoginOpened" @hide="onHideLoginDialog">
      <div id="firebaseui-auth-container" style="background-color: white;"></div>
    </q-dialog>

  </q-layout>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import * as firebaseui from 'firebaseui'

export default {
  data () {
    return {
      leftDrawer: true,
      firestoreLoginOpened: false,
      ui: null
    }
  },
  methods: {
    onHideLoginDialog () {
      // delete this.ui
      // this.ui = null
    },
    showLoginDialog () {
      this.firestoreLoginOpened = true
      this.$nextTick(() => {
        if (this.ui != null) {
          return
        }
        const uiConfig = {
          signInSuccessUrl: '/home',
          signInOptions: [
            firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            firebase.auth.EmailAuthProvider.PROVIDER_ID
          ],
          credentialHelper: firebaseui.auth.CredentialHelper.GOOGLE_YOLO
        }
        this.ui = new firebaseui.auth.AuthUI(firebase.auth())
        this.ui.start('#firebaseui-auth-container', uiConfig)
      })
    }
  }
}
</script>

<style>
</style>
